export default __webpack_public_path__ + "static/media/dad-daughter.13530995.png";